import { render, staticRenderFns } from "./AnalysisConfiguration.vue?vue&type=template&id=35468bd4&scoped=true"
import script from "./AnalysisConfiguration.vue?vue&type=script&lang=js"
export * from "./AnalysisConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AnalysisConfiguration.vue?vue&type=style&index=0&id=35468bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35468bd4",
  null
  
)

export default component.exports